let audioCtx = null;

const TONES = {
  ding: {
    label: 'Ding',
    play: ctx => {
      const now = ctx.currentTime;
      const gain = ctx.createGain();
      gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.5, now);
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.3);

      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(800, now);
      osc.connect(gain);
      osc.start(now);
      osc.stop(now + 0.3);
    },
  },
  flip: {
    label: 'Flip',
    play: ctx => {
      const now = ctx.currentTime;

      const g1 = ctx.createGain();
      g1.connect(ctx.destination);
      g1.gain.setValueAtTime(0.01, now);
      g1.gain.linearRampToValueAtTime(0.5, now + 0.02);
      g1.gain.exponentialRampToValueAtTime(0.01, now + 0.12);

      const o1 = ctx.createOscillator();
      o1.type = 'triangle';
      o1.frequency.setValueAtTime(880, now);
      o1.frequency.exponentialRampToValueAtTime(660, now + 0.1);
      o1.connect(g1);
      o1.start(now);
      o1.stop(now + 0.12);

      const g2 = ctx.createGain();
      g2.connect(ctx.destination);
      g2.gain.setValueAtTime(0.01, now + 0.08);
      g2.gain.linearRampToValueAtTime(0.4, now + 0.1);
      g2.gain.exponentialRampToValueAtTime(0.01, now + 0.2);

      const o2 = ctx.createOscillator();
      o2.type = 'sine';
      o2.frequency.setValueAtTime(400, now + 0.08);
      o2.frequency.exponentialRampToValueAtTime(200, now + 0.18);
      o2.connect(g2);
      o2.start(now + 0.08);
      o2.stop(now + 0.2);
    },
  },
  chime: {
    label: 'Chime',
    play: ctx => {
      const now = ctx.currentTime;

      [0, 0.12, 0.24].forEach((offset, i) => {
        const g = ctx.createGain();
        g.connect(ctx.destination);
        g.gain.setValueAtTime(0.01, now + offset);
        g.gain.linearRampToValueAtTime(0.35, now + offset + 0.03);
        g.gain.exponentialRampToValueAtTime(0.01, now + offset + 0.25);

        const o = ctx.createOscillator();
        o.type = 'sine';
        o.frequency.setValueAtTime([523, 659, 784][i], now + offset);
        o.connect(g);
        o.start(now + offset);
        o.stop(now + offset + 0.25);
      });
    },
  },
};

let activeTone = 'flip';

const setTaskNotificationTone = toneId => {
  if (TONES[toneId]) {
    activeTone = toneId;
  }
};

const getAudioContext = () => {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch {
      return null;
    }
  }
  return audioCtx;
};

// IMPORTANTE: resume() so funciona dentro de um handler de gesto do usuario
// (click/touch/keydown). Fora de um gesto, o navegador ignora silenciosamente.
// Isso e uma restricao do navegador, nao do codigo. Nao existe API JavaScript
// para persistir permissao de audio entre recarregamentos de pagina.
const isAudioBlocked = () => {
  if (!audioCtx) return true;
  return audioCtx.state !== 'running';
};

// Deve ser chamado DENTRO de um event handler de gesto (click/touch/keydown).
const tryUnlockAudio = () => {
  const ctx = getAudioContext();
  if (!ctx) return false;
  if (ctx.state === 'running') return true;

  ctx.resume();
  return false;
};

const playTone = () => {
  const ctx = getAudioContext();
  if (!ctx || ctx.state !== 'running') return false;

  const tone = TONES[activeTone] || TONES.flip;
  try {
    tone.play(ctx);
    return true;
  } catch {
    return false;
  }
};

const playTaskPopupSound = async notificationId => {
  getAudioContext();

  if (playTone()) return;

  if (!navigator.locks || typeof navigator.locks.request !== 'function') {
    if (document.hasFocus()) {
      playTone();
    }
    return;
  }

  try {
    await navigator.locks.request(
      `task-popup-sound-${notificationId}`,
      { ifAvailable: true, mode: 'exclusive' },
      async lock => {
        if (!lock) return;
        playTone();
        await new Promise(resolve => setTimeout(resolve, 600));
      }
    );
  } catch {
    // Silencioso
  }
};

// Listener global: QUALQUER clique/toque/tecla em qualquer lugar da pagina
// destrava o audio. Durante o uso normal do CRM, o usuario clica em
// conversas, menus, etc. antes de qualquer notificacao chegar - entao o
// audio ja esta destravado quando o popup aparece. O botao "Clique para
// ativar o som" no popup so aparece no cenario raro de uma notificacao
// chegar antes de qualquer interacao (ex.: logo apos recarregar a pagina).
const unlockAudioOnInteraction = () => {
  tryUnlockAudio();
};

['click', 'touchstart', 'keydown'].forEach(event => {
  document.addEventListener(event, unlockAudioOnInteraction);
});

export { playTaskPopupSound, setTaskNotificationTone, TONES };
